import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Footer, MarketingHeader, SEO } from '@/components';
import { ChildSupportCalculator } from '@/components/child-support/ChildSupportCalculator';
import { track } from '@/lib/analytics';
import { CHILD_SUPPORT_STATES } from '@/lib/child-support/schemas';

const featuredStates = ['california', 'texas', 'new-york', 'florida'] as const;

function ChildSupportHubPage() {
  useEffect(() => {
    track('Child Support Hub View');
  }, []);

  return (
    <div className='min-h-screen bg-white'>
      <SEO
        title='Child support calculator by state | Harbor'
        description='Get a quick child support estimate by state. Fast inputs, non-legal estimate, and email delivery.'
        path='/child-support-calculator'
      />
      <MarketingHeader />

      <section className='bg-primary/5 pt-32 pb-12'>
        <div className='mx-auto max-w-4xl px-6 text-center'>
          <h1 className='mb-4 text-4xl font-bold text-gray-900 md:text-5xl'>
            Child support estimate calculator
          </h1>
          <p className='mx-auto max-w-2xl text-xl leading-relaxed text-gray-600'>
            Estimate monthly support with quick inputs for all 50 states plus DC. This tool is
            educational only and not legal advice.
          </p>
        </div>
      </section>

      <div className='mx-auto max-w-7xl px-6 py-12'>
        <ChildSupportCalculator />

        <h2 className='mb-4 mt-12 text-2xl font-bold text-gray-900'>Popular state pages</h2>
        <div className='flex flex-wrap gap-2'>
          {featuredStates.map((slug) => {
            const state = CHILD_SUPPORT_STATES.find((s) => s.slug === slug);
            if (!state) return null;
            return (
              <Link
                key={slug}
                to='/child-support-calculator/$state'
                params={{ state: slug }}
                className='inline-block rounded-full border border-gray-200 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-800 hover:border-primary hover:text-primary'
              >
                {state.name}
              </Link>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export const Route = createFileRoute('/child-support-calculator/')({
  component: ChildSupportHubPage,
});
